import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MotorReservaRatesAPI from '../../api/motorReservaRates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getRecords({ commit }) {
    commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isFetching: true });
    try {
      const response = await MotorReservaRatesAPI.get();
      commit(types.SET_MOTOR_RESERVA_RATES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRecord({ commit }, data) {
    commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isCreating: true });
    try {
      const response = await MotorReservaRatesAPI.create(data);
      commit(types.ADD_MOTOR_RESERVA_RATE, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateRecord({ commit }, { id, ...updateObj }) {
    commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isUpdating: true });
    try {
      const response = await MotorReservaRatesAPI.update(id, updateObj);
      commit(types.EDIT_MOTOR_RESERVA_RATE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteRecord({ commit }, id) {
    commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isDeleting: true });
    try {
      await MotorReservaRatesAPI.delete(id);
      commit(types.DELETE_MOTOR_RESERVA_RATE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_RATES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_MOTOR_RESERVA_RATES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_MOTOR_RESERVA_RATES]: MutationHelpers.set,
  [types.ADD_MOTOR_RESERVA_RATE]: MutationHelpers.create,
  [types.EDIT_MOTOR_RESERVA_RATE]: MutationHelpers.update,
  [types.DELETE_MOTOR_RESERVA_RATE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
